import { useAuth0 } from '@auth0/auth0-react'
import {
  useGetListItems,
  useMutateDeleteQuestionItem,
  useMutateItem,
} from '../../hooks/entityMethodsHook'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import Api from '../../lib/api'

export const useMutatequestionadd = (key: any) => {
  const uri = `questions`
  return useMutateItem(key, uri)
}

export const useGetQuestions = (
  queryKey: string,
  enabled?: boolean | undefined,
  query?: string | undefined
) => {
  const uri = 'questions/question' + (query ?? '')
  return useGetListItems(queryKey, uri, enabled)
}
export const useMutateDeleteQuestion = (key: any) => {
  const uri = `questions`
  return useMutateDeleteQuestionItem(key, uri)
}
export const useUpdateQuestion = () => {
  const { getAccessTokenSilently } = useAuth0()
  const queryClient = useQueryClient()

  const updateQuestion = useMutation(
    async ({ id, data }: { id: string; data: any }) => {
      const token = await getAccessTokenSilently()
      const response = await Api.put(`v1/questions/${id}`, data, token)
      return response.data
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries()
      },
    }
  )

  return updateQuestion
}
